import $ from "jquery";

$(function () {
	
	// Function to open the burger menu
	let moreBtn = $(".header .more-trigger, .header .close-more-menu, .header .btn-burger-container");

	moreBtn.on("click", function (e) {
		e.preventDefault();
		$("body, html").toggleClass("js-more-menu-open");
	});

	$(".more-nav .menu-item a").on("click", function () {
		$("body, html").toggleClass("js-more-menu-open");
	});


	// Function to add height to main tag for fixed header
	function adjustMainMargin() {
		var headerHeight = $('.header').outerHeight();
		$('main').css('margin-top', headerHeight + 'px');
	}

	adjustMainMargin();

	let resizeTimer;
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(adjustMainMargin, 150);
	});
});
